import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import VideoLibraryOutlinedIcon from '@mui/icons-material/VideoLibraryOutlined';
import LibraryBooksOutlinedIcon from '@mui/icons-material/LibraryBooksOutlined';

type CardStatConfig = {
    type: string;
    title: string;
    icon: React.ElementType;
    bgColor: string;
    textColor: string;
};

export const cardStatsConfig: CardStatConfig[] = [
    {
        type: 'users',
        title: 'Total Users',
        icon: PersonOutlineOutlinedIcon,
        bgColor: '#EEFBE5',
        textColor: '#03B568',
    },
    {
        type: 'subjects',
        title: 'Total Subjects',
        icon: MenuBookOutlinedIcon,
        bgColor: '#ECEDFF',
        textColor: '#868BDE',
    },
    {
        type: 'videos',
        title: 'Total Videos',
        icon: VideoLibraryOutlinedIcon,
        bgColor: '#E5F8FE',
        textColor: '#26C6F9',
    },
    {
        type: 'reference',
        title: 'Total Reference',
        icon: LibraryBooksOutlinedIcon,
        bgColor: '#FFFADA',
        textColor: '#E5C601',
    },
];